function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();

}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      console.log('safafd 1');
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          console.log('this');
        console.log(this);

        this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {

        console.log('safafd 3');
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    console.log('hidden');
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    if ($('ul').hasClass('dbundleSlider')) {
      this.slider = this.querySelector('ul.dbundleSlider');
    }
    else {
      this.slider = this.querySelector('ul');
    }
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');


    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {

    //if (!this.pageCount || !this.pageTotal) return;


    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    // console.log(this.totalPages)
    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    var prog = (this.currentPage / this.totalPages);
    // console.log(prog);
    $(".slider-pagination-progressbar-fill").css({ 'transform': 'translate3d(0px, 0px, 0px) scaleX(' + prog + ') scaleY(1)' })
    $(".slider-counter span").not('.hide').removeClass('slider-counter--current');
    $(".slider-counter span").not('.hide').eq(this.currentPage - 1).addClass('slider-counter--current')

    //this.pageCount.textContent = this.currentPage;
    //this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();

    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    console.log(slideScrollPosition);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productSingleObject = JSON.parse(document.getElementById('product-data').textContent);
    this.addEventListener('change', this.onVariantChange);
    // console.log("i am imran");
    this.colorSelection()
  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();

      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setShippingExclusions(); // set this.shippingExclusions

      this.setShippingExlusionsLineItemProperty(this.currentVariant);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  colorSelection() {
    const options = document.querySelectorAll('.color-label');
    options.forEach((option) => {
      option.addEventListener('click', () => {
        // Remove the 'selected' class from all options
        options.forEach((o) => {
          o.classList.remove('active');
        });
        // Add the 'selected' class to the clicked option
        option.classList.add('active');
      });
    });

  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    var option1 = this.currentVariant.option1.toLowerCase().replace(/\s+/g, '');
    var option2 = this.currentVariant.option2 == null ? '' : this.currentVariant.option2.toLowerCase().replace(/\s+/g, '');
    // console.log(option2, this.currentVariant);
    var firstimg = 0;
    $('.product__media-item').addClass('hide');
    var page_handle = $('variant-radios').attr('data-url');
    if(page_handle == '/products/infusions-smart-showerhead-discovery-set-bundle-1'){
    }
    else{
     if (option2 == '') {
      this.currentVariant.option2 = "2.5 gal/min"
      this.colorSelection()
    } 
    }


    $('.sticty-addtocart .color-label, .sticty-addtocart .flow-option-label').removeClass('active');
    $('.custom-options').prop("checked", false);
    $('.custom-options[value="' + this.currentVariant.option1 + '"]').parents('.variant-val').find('.color-label').addClass('active');
    $('.custom-options[value="' + this.currentVariant.option2 + '"]').parents('.variant-val').find('.flow-option-label').addClass('active');

    $('.custom-options[value="' + this.currentVariant.option1 + '"]').prop("checked", true);
    $('.custom-options[value="' + this.currentVariant.option2 + '"]').prop("checked", true);

    // console.log('Global js variant event code');
    if ($('body').hasClass('templateB-landing')) {
    }
    else {
      if (this.currentVariant.option2 == '2.5 gal/min' || this.currentVariant.option2 == '2.5 gpm') {
        $('[data-option-footnote]').addClass('is-active');
        $('.product-form__input.is-Flow').removeClass('WaterSense-option-selected');

      } else {
        $('[data-option-footnote]').removeClass('is-active');
        $('.product-form__input.is-Flow').addClass('WaterSense-option-selected');
      }
    }

    if ($('body').hasClass('smart-showerhead-page')) {
      $('product-modal .product-media-modal__content img').addClass('productImagehidden');
      $('product-modal .product-media-modal__content img').each(function () {
        var datacolor = $(this).attr('alt').toLowerCase().replace(/ /g, '');
        if (datacolor.includes(option1) && datacolor.includes(option2)) {
          $(this).removeClass('productImagehidden');
        }
      });
    }

    if ($('ul').hasClass('hiddenOnBundle')) {

      if ($('body').hasClass('templateB-landing')) {
        if ($('.templateB-landing').hasClass('show-section1')) {
          console.log('show-section1');

          if (this.currentVariant.option2 == '2.5 gal/min' || this.currentVariant.option2 == '2.5 gpm') {
            $('.show-section1 .sectionaddons [data-option-footnote]').addClass('is-active');
            $('.show-section1 .sectionaddons .product-form__input.is-Flow').removeClass('WaterSense-option-selected');
          } else {
            $('.show-section1 .sectionaddons [data-option-footnote]').removeClass('is-active');
            $('.show-section1 .sectionaddons .product-form__input.is-Flow').addClass('WaterSense-option-selected');
          }
          var gethtml = '';
          $('.sectionaddons .hiddenOnBundle .bundlepageeach').each(function () {
            var datacolor = $(this).data('color');
            if (datacolor.includes(option1) && datacolor.includes(option2)) {
              $(this).removeClass('hide');
              gethtml += $(this).html();
              if (firstimg == 0) {
                $(this).css({ 'width': '100%' });
              }
              firstimg = 1;
            }
          });
          $('.sectionaddons .dbundleSlider').html(gethtml);
          $('.sectionaddons .dbundleSlider li').removeClass('hide');
          if ($(window).width() >= 991) {
            $('.sectionaddons .dbundleSlider').removeClass('slick-initialized slick-slider slick-dotted');
            $('.sectionaddons .dbundleSlider').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true
            });
          }
          else {
            if ($('.sectionaddons .dbundleSlider').hasClass('slick-initialized')) {
              $('.sectionaddons .dbundleSlider').slick('unslick');
            }
          }

        }
        else {

          console.log('show-section2');

          if (this.currentVariant.option2 == '2.5 gal/min' || this.currentVariant.option2 == '2.5 gpm') {
            $('.show-section2 .norm-product [data-option-footnote]').addClass('is-active');
            $('.show-section2 .norm-product .product-form__input.is-Flow').removeClass('WaterSense-option-selected');
          } else {
            $('.show-section2 .norm-product [data-option-footnote]').removeClass('is-active');
            $('.show-section2 .norm-product .product-form__input.is-Flow').addClass('WaterSense-option-selected');
          }
          var gethtml = '';
          $('.norm-product .hiddenOnBundle .bundlepageeach').each(function () {
            var datacolor = $(this).data('color');
            if (datacolor.includes(option1) && datacolor.includes(option2)) {
              $(this).removeClass('hide');
              gethtml += $(this).html();
              if (firstimg == 0) {
                $(this).css({ 'width': '100%' });
              }
              firstimg = 1;
            }
          });
          $('.norm-product .dbundleSlider').html(gethtml);
          $('.norm-product .dbundleSlider li').removeClass('hide');
          if ($(window).width() >= 991) {
            $('.norm-product .dbundleSlider').removeClass('slick-initialized slick-slider slick-dotted');
            $('.norm-product .dbundleSlider').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true
            });
          }
          else {
            if ($('.norm-product .dbundleSlider').hasClass('slick-initialized')) {
              $('.norm-product .dbundleSlider').slick('unslick');
            }
          }
        }

      }
      else {


        // console.log('Bundle page');
        var gethtml = '';
        $('.hiddenOnBundle .bundlepageeach').each(function () {
          var datacolor = $(this).data('color');
          if (datacolor.includes(option1) && datacolor.includes(option2)) {
            $(this).removeClass('hide');
            gethtml += $(this).html();
            if (firstimg == 0) {
              $(this).css({ 'width': '100%' });
            }
            firstimg = 1;
          }
        });
        $('.dbundleSlider').html(gethtml);
        $('.dbundleSlider li').removeClass('hide');
        if ($(window).width() >= 991) {
          $('.dbundleSlider').removeClass('slick-initialized slick-slider slick-dotted');
          $('.dbundleSlider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
          });
        }
        else {
          if ($('.dbundleSlider').hasClass('slick-initialized')) {
            $('.dbundleSlider').slick('unslick');
          }
        }

      }
    }
    else {
      console.log('Normal page');
      $('.product__media-item').each(function () {
        var datacolor = $(this).data('color');
        if (datacolor.includes(option1) && datacolor.includes(option2)) {
          $(this).removeClass('hide');
          if (firstimg == 0) {
            $(this).css({ 'width': '100%' });
          }
          firstimg = 1;
        }
      });
    }


    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    //window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if ($('ul').hasClass('hiddenOnBundle')) {
      console.log('No updateURL');
    }
    else {
      if ($('body').hasClass('templateB-landing')) {
        console.log('HP No updateURL');
      }
      else {
        console.log('this.dataset.url----');
        console.log(this.dataset.url);
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        var window_path = window.location.pathname;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        // window.history.replaceState({ }, '', window_path + '?variant='+this.currentVariant.id);      
        console.log(window_path + '?variant=' + this.currentVariant.id);
      }
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    console.log('this.dataset.section-----');
    console.log(this.dataset.section);
    console.log('updateVariantInput-----');
    console.log(productForms);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

  }
  setShippingExclusions() {

    // instead of long checks for nested props
    // do try-catch
    // bail if anything goes wrong
    try {
      // check if product has exclusions_option
      var optionPosition = getOptionPosition(this.productSingleObject, this.productSingleObject.shipping_exclusions.sh_exclusions_option); // returns 1, 2, 3
      console.log(optionPosition)
      if (optionPosition) {
        // parse exclusions options data into and array of form [[1.8, ["CA","HI","WA"]], [2.8, ["NY"]]]
        // sort by threshold value in increasing order
        var exclusionsArr = getShippingExclusionsParsed(this.productSingleObject.shipping_exclusions.sh_exclusions_thresholds).sort(function (a, b) {
          return a[0] - b[0];
        }); // set this.shippingExclusions - map of variant ID with a list of excluded states, if any
        // a state will be exclused if numeric value of exclusions_option (i.e. flow) is greater of this state's treshold
        console.log(exclusionsArr)
        this.shippingExclusions = getExclusionsMap(this.productSingleObject, optionPosition, exclusionsArr);
      }
    } catch (error) {
      console.warn("[".concat(this.name, "] - ").concat(error.message || error));
    }
  }
  setShippingExlusionsLineItemProperty(variant) {
    if (variant && this.shippingExclusions) {
      if (this.shippingExclusions.has(variant.id)) {
        (0, _jquery.default)(selectors.shippingExclusions).val(this.shippingExclusions.get(variant.id).join(','));
      } else {
        (0, _jquery.default)(selectors.shippingExclusions).val('');
      }
    }
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if ($('body').hasClass('dbundle-page') || $('body').hasClass('templateB-landing')) {
      }
      else {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        var get_price = $(price).find('.price__regular .price-item.price-item--regular').html();
        var get_compare_price = $(price).find('.price__sale .price-item.price-item--regular').html();
        if ($('body').hasClass('show-section1')) {
          if (get_compare_price != '') {
            var price_html = '<span class="tab-product-price">' + get_price + '</span><s class="price-item price-item--regular"><span class="compare-atprice-tab-product">' + get_compare_price + '</span></s>';
          } else {
            var price_html = '<span class="tab-product-price">' + get_price + '</span>';
          }
          $('.sectionaddons').find('.product-add-tocart-price').html(price_html);
        } else if ($('body').hasClass('show-section2')) {
          if (get_compare_price != '') {
            var price_html = '<span class="tab-product-price">' + get_price + '</span><s class="price-item price-item--regular"><span class="compare-atprice-tab-product">' + get_compare_price + '</span></s>';
          } else {
            var price_html = '<span class="tab-product-price">' + get_price + '</span>';
          }
          $('.norm-product').find('.product-add-tocart-price').html(price_html);
        }
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const dummy_addButton = productForm.querySelector('[name="dummy"]');
    const dummy_addButtonText = productForm.querySelector('[name="dummy"] > span');
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    var lp_atc = $('body').hasClass('landing-page');
    if (lp_atc) {
      if ($('.org_atc').hasClass('lp-added')) {
        $('.org_atc').removeClass('lp-added');
      }
    }
    var check_btn = $('div').hasClass('button-with-dummy');
    console.log(check_btn, "yes its me", dummy_addButton);

    if (disable) {
      /* if (check_btn) { dummy_addButton.setAttribute('disabled', true); }
       addButton.setAttribute('disabled', true);*/
      if (text) addButtonText.textContent = text;
      if (text) {
        $('.mob_atc').html(text);
      }
      if (check_btn) { dummy_addButtonText.textContent = text; }
      $('.pre-order-date-wraper').html('');
    } else {
      addButton.removeAttribute('disabled');
      if (check_btn) { dummy_addButton.removeAttribute('disabled'); }
      $('.button-with-dummy .dummy-atc').removeClass('disabled-dummy');
      var check_text = $('.custom-select__select option[data-value="' + this.currentVariant.id + '"]').data('text');
      var pre_order_date = $('.custom-select__select option[data-value="' + this.currentVariant.id + '"]').data('date');

      if (check_text == 'Pre-Order') {
        $('.pre-order-date-wraper').html('<p>Product will ship by ' + pre_order_date + '</p>');
        addButtonText.textContent = 'Pre-Order';
        if (check_btn) { dummy_addButtonText.textContent = 'Pre-Order'; }
        $('.mob_atc').html('Pre-order');
      } else {
        $('.pre-order-date-wraper').html('');
        addButtonText.textContent = window.variantStrings.addToCart;
        if (check_btn) { dummy_addButtonText.textContent = window.variantStrings.addToCart; }
        $('.mob_atc').html(window.variantStrings.addToCart);
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
/**
 * @param {*} exlusionsArray from productSingleOptions
 * @returns array of form [[1.8, ["CA","HI","WA"]], [2.8, ["NY"]]]
 */
var getShippingExclusionsParsed = function getShippingExclusionsParsed(exlusionsArray) {
  if (!exlusionsArray || !Array.isArray(exlusionsArray)) {
    return [];
  }

  var result = exlusionsArray.reduce(function (arr, splitString) {
    var splits = splitString.split('::');

    if (splits && splits.length === 2) {
      var exclusionsList = splits[1].split(',').map(function (excl) {
        return excl.trim();
      });
      return [].concat(_toConsumableArray(arr), [[parseFloat(splits[0]), exclusionsList]]);
    }

    return arr;
  }, []);
  return result;
};
/**
 * @param {*} productObject
 * @param {*} optionDowncase
 * @returns {1 | 2 | 3} - option position if present on product
 */


var getOptionPosition = function getOptionPosition(productObject, optionDowncase) {

  if (!productObject || !Array.isArray(productObject.options || !optionDowncase)) {
    return false;
  }

  var optionsDowncase = productObject.options_with_values.map(function (op) {

    return _objectSpread({}, op, {
      name: op.name.toLowerCase()
    });
  });
  console.log(optionsDowncase);
  var opt = optionsDowncase.find(function (op) {
    return op.name === 'flow';
  });
  return opt ? opt.position : 0;
};
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
